<script setup>
import { onMounted, ref } from 'vue';
import { Vue3Lottie } from 'vue3-lottie';

import AnimatedLogo from '@/assets/lotties/animated_logo.json';
import { formStore } from '@/stores/form';

const form = formStore();

const currentImage = ref(null);
let images = [];

const fetchData = async () => {
  images = await form.fetchMaatschappijenLogos();
  currentImage.value = images[0];
};

const startImageLoader = () => {
  let currentIndex = 0;
  setInterval(() => {
    currentIndex = (currentIndex + 1) % images.length;
    currentImage.value = images[currentIndex];
  }, 2000);
};

onMounted(async () => {
  // if tenant is insuretostudy, do not fetch maatschappijlogos for the laoder
  if (form.tenant !== 'insuretostudy') {
    await fetchData();
    startImageLoader();
  }
});
</script>

<template>
  <div class="overlay">
    <div class="row">
      <div class="col-12">
        <h2 v-html="$t('general.loader.title', { tagopen: '<span>', tagclose: '</span>' })" />
        <p>{{ $t('general.loader.body') }}</p>
      </div>
      <div class="col-12">
        <Vue3Lottie
          :animation-data="AnimatedLogo"
          :width="100"
        />
      </div>
      <div class="col-12 imageLoader">
        <transition
          name="fade"
          mode="out-in"
        >
          <img
            v-if="currentImage"
            :key="currentImage"
            :src="currentImage"
            class="fade-in-out"
            alt="Logos"
          >
        </transition>
      </div>
      <div class="col-12 py-5 d-flex justify-content-center">
        <BaseIconWithLabel
          class="ps-1"
          image-name="/svg/usp.svg"
          before
        >
          <strong>{{ $t('general.loader.usp') }}</strong>
        </BaseIconWithLabel>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  width: 100%;
  top: 0;
  height: 100%;
  z-index: 99;
  background-color: rgba(255, 255, 255);
  animation: fadeIn 0.5s ease-in;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}

.imageLoader {
  height: 10rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-in-out {
  max-width: 100%;
  height: 10rem;
}
</style>
